import React, { useEffect, useState } from 'react';
import { UTILITY_OFFLINE_PAYMENT_TAB } from '../../Utils/appConstants';
import BBPSIP from '../bharatBillpayIP/index.js';
import BBPSIMW from '../bharatBillpayImWallet/index.js';
import History from '../bharatBillpayImWallet/history';
import Complaint from '../bharatBillpayImWallet/complaint';
import Maintenance from '../Maintenance';
import { reactLocalStorage } from 'reactjs-localstorage';
import 'antd/dist/antd.css';
import { Tabs, Input, Row, Col, Card, Modal, Button } from 'antd';
import { SearchOutlined, HistoryOutlined, CustomerServiceOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_URL } from '../../config';

const { TabPane } = Tabs;
const { Search } = Input;

// Brand colors
const PRIMARY_COLOR = '#C9262C';
const ACCENT_COLOR = '#FFDD09';

function BBPSPayment(props) {
  const [tabKey, setTabKey] = useState('2'); // Default to BBPS-I
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabledModal, setDisabledModal] = useState({ visible: false, title: '', message: '' });

  useEffect(() => {
    console.log('props.location.tab -----------', props.location.tab);
    if (props.location.tab) {
      setTabKey(props.location.tab);
    }
  }, [props.location.tab]);

  // Fetch appInfo on component mount
  useEffect(() => {
    fetchAppInfo();
  }, []);

  const fetchAppInfo = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL + `/appinfo`);
      console.log('AppInfo fetched:', response.data);
      setAppInfo(response.data);
    } catch (err) {
      console.error("Failed to fetch app info", err);
    } finally {
      setLoading(false);
    }
  };

  // Get feature flags
  const isBbpsImWalletAvailable = appInfo?.bbpsImWalletEnabled || false;

  const showDisabledModal = (title, message) => {
    setDisabledModal({
      visible: true,
      title: title,
      message: message
    });
  };

  const onchangeTab = (index) => {
    if (index === '2' && !isBbpsImWalletAvailable) {
      showDisabledModal(
        'BBPS Service Disabled',
        'BBPS service is currently disabled. Please contact support for more information.'
      );
      return;
    }
    reactLocalStorage.set(UTILITY_OFFLINE_PAYMENT_TAB, index, true);
    setTabKey(index);
  };

  const getValidTabKey = () => {
    if (tabKey === '2' && !isBbpsImWalletAvailable) {
      return '3';
    }
    return tabKey;
  };

  const activeTabKey = getValidTabKey();
  const isUnderMaintenance = false;

  console.log('BBPS Status:', {
    bbpsImWalletEnabled: isBbpsImWalletAvailable,
    appInfo: appInfo
  });

  const tabStyles = `
    .bbps-full-width .ant-tabs-nav {
      margin-bottom: 24px;
    }
    .bbps-full-width .ant-tabs-nav .ant-tabs-tab {
      margin-right: 20px !important;
    }
    .bbps-full-width .ant-tabs-nav .ant-tabs-tab:last-child {
      margin-right: 0 !important;
    }
    .bbps-full-width .ant-tabs-tab .tabtext {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: bold
    }
    .bbps-full-width .ant-tabs-tab .tabtext span {
      display: flex;
      align-items: center;
    }
    .bbps-search-bar {
      margin-bottom: 0px;
    }
    .bbps-search-bar .ant-input-group-wrapper {
      width: 100%;
    }
    .bbps-search-bar .ant-input-affix-wrapper {
      border-radius: 8px;
    }
    .bbps-search-bar .ant-input-affix-wrapper:focus,
    .bbps-search-bar .ant-input-affix-wrapper-focused {
      border-color: ${PRIMARY_COLOR};
      box-shadow: 0 0 0 2px ${PRIMARY_COLOR}20;
    }
    .bbps-search-bar .ant-btn-primary {
      background: ${PRIMARY_COLOR};
      border-color: ${PRIMARY_COLOR};
    }
    .bbps-search-bar .ant-btn-primary:hover {
      background: ${PRIMARY_COLOR}dd;
      border-color: ${PRIMARY_COLOR}dd;
    }
    .bbps-header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0px;
    }
    .bbps-logo-img {
      cursor: pointer;
      transition: transform 0.3s;
    }
    .bbps-logo-img:hover {
      transform: scale(1.05);
    }
  `;

  const renderDisabledPlaceholder = (serviceName, fallbackTab) => {
    let fallbackLabel = '';
    if (fallbackTab === '3') fallbackLabel = 'History';
    else fallbackLabel = 'another service';

    const goToFallback = () => {
      setTabKey(fallbackTab);
      reactLocalStorage.set(UTILITY_OFFLINE_PAYMENT_TAB, fallbackTab, true);
    };

    return (
      <div style={{
        textAlign: 'center',
        padding: '60px 20px',
        background: '#fef2f2',
        borderRadius: '8px',
        margin: '20px 0'
      }}>
        <WarningOutlined style={{ fontSize: '48px', color: '#ef4444', marginBottom: '16px' }} />
        <h3 style={{ color: '#991b1b', marginBottom: '8px' }}>Service Disabled</h3>
        <p style={{ color: '#7f1d1d' }}>
          {serviceName} is currently disabled. 
          Please contact support for more information.
        </p>
        {fallbackTab && (
          <Button 
            type="primary" 
            onClick={goToFallback}
            style={{ marginTop: '16px' }}
          >
            Go to {fallbackLabel}
          </Button>
        )}
      </div>
    );
  };

  return (
    <div>
      <style>{tabStyles}</style>
      {isUnderMaintenance ? (
        <Maintenance />
      ) : (
        <div className="content-wrapper pt-2" style={{ padding: 0 }}>
          <div className="content-header my-0 py-0">
            <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
              {/* Header with title on left and logo on right - now using tabBarExtraContent instead */}
            </div>
          </div>
          <div className="content" style={{ padding: 0 }}>
            <div className="container-fluid pt-2 pb-5" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="row" style={{ margin: 0 }}>
                <div className="col-md-12" style={{ padding: 0 }}>
                  <Card
                    className="rounded-0"
                    style={{
                      borderRadius: 0,
                      margin: 0,
                      boxShadow: 'none',
                      border: 'none'
                    }}
                    bodyStyle={{ padding: '20px' }}
                  >
                    <Tabs
                      className="recharge-tabs bbps-full-width"
                      activeKey={activeTabKey}
                      defaultActiveKey="2"
                      onChange={onchangeTab}
                      size="large"
                      tabBarGutter={20}
                      style={{ width: '100%' }}
                      tabBarExtraContent={
                        <img
                          className='bbps-logo-img'
                          src='../images/bharat_connect.png'
                          width="100"
                          alt='Bharat Connect'
                          style={{ cursor: 'pointer' }}
                        />
                      }
                    >
                      {/* BBPS-II is hidden – removed TabPane key="1" */}

                      <TabPane
                        key="2"
                        tab={
                          <div className="tabtext" title="BBPS">
                            <span>
                              <img height="35" width="35" src="/bbps/b_mnemonic.png" alt="BBPS" />
                            </span>
                            BBPS
                          </div>
                        }
                      >
                        {isBbpsImWalletAvailable ? (
                          <BBPSIMW />
                        ) : (
                          renderDisabledPlaceholder('BBPS Service', '3')
                        )}
                      </TabPane>

                      <TabPane
                        key="3"
                        tab={
                          <div className="tabtext" title="Transaction History">
                            <span>
                              <HistoryOutlined style={{ fontSize: '20px' }} />
                            </span>
                            History
                          </div>
                        }
                      >
                        <History searchTerm={searchTerm} apiProvider="all" />
                      </TabPane>

                      <TabPane
                        key="4"
                        tab={
                          <div className="tabtext" title="Support Center">
                            <span>
                              <CustomerServiceOutlined style={{ fontSize: '20px' }} />
                            </span>
                            Support
                          </div>
                        }
                      >
                        <Complaint />
                      </TabPane>
                    </Tabs>

                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Disabled Service Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <InfoCircleOutlined style={{ color: '#faad14', fontSize: '20px' }} />
            <span>{disabledModal.title}</span>
          </div>
        }
        open={disabledModal.visible}
        onOk={() => setDisabledModal({ visible: false, title: '', message: '' })}
        onCancel={() => setDisabledModal({ visible: false, title: '', message: '' })}
        okText="Got It"
        cancelButtonProps={{ style: { display: 'none' } }}
        centered
      >
        <div style={{ padding: '8px 0' }}>
          <p style={{ fontSize: '14px', color: '#4a5568', margin: 0 }}>
            {disabledModal.message}
          </p>
        </div>
      </Modal>
    </div>
  );
}

export default BBPSPayment;